<div class="text-small">
    <div class="fw-bold">Contact Us</div>
    <div>Email: <a href="mailto:support@rentability.ca">support&#64;rentability.ca</a></div>
    <div>Proudly Made in Canada</div>
</div>